import CharacterList from "../components/CharacterList";

const CharactersPage = () => {
  document.title = "Персонажи | Кампания из Эвенглена";
  return <CharacterList />;
};

export default CharactersPage;
